(function () {
  'use strict';

  // === AFTERPAY BADGE — product pages only ===
  function getPrice() {
    const sale = document.querySelector('.price__container .price-item--sale');
    const regular = document.querySelector('.price__container .price-item--regular');
    const el = sale || regular;
    if (!el) return null;
    const m = el.textContent.match(/([\d,]+\.?\d*)/);
    return m ? parseFloat(m[1].replace(',', '')) : null;
  }

  function renderBadge(price) {
    const existing = document.getElementById('sk-afterpay');
    const want = price && price >= 1 && price <= 2000;
    if (!want) { if (existing) existing.remove(); return; }
    const inst = (price / 4).toFixed(2);
    const container = document.querySelector('.price__container');
    if (!container) { if (existing) existing.remove(); return; }
    // Idempotent: same instalment, still attached in the right place — no DOM writes,
    // so the MutationObserver below has nothing to react to and can't loop.
    if (existing && existing.dataset.inst === inst && existing.previousElementSibling === container) return;
    if (existing) existing.remove();
    const badge = document.createElement('p');
    badge.id = 'sk-afterpay';
    badge.dataset.inst = inst;
    badge.style.cssText = 'margin:6px 0 0; font-size:13px; color:#444; line-height:1.4;';
    badge.innerHTML =
      'or 4 x <strong>$' + inst + ' AUD</strong> with ' +
      '<a href="https://www.afterpay.com/en-AU/how-it-works" target="_blank" rel="noopener" ' +
      'style="color:#000; font-weight:700; text-decoration:none; background:#B2FCE4; padding:1px 5px; border-radius:3px;">Afterpay</a>' +
      ' <a href="https://www.afterpay.com/en-AU/how-it-works" target="_blank" rel="noopener" ' +
      'aria-label="How Afterpay works — opens in a new tab" ' +
      'style="display:inline-block; font-size:15px; color:#595959; padding:10px; margin:-10px -4px -10px -4px;">ⓘ</a>';
    container.after(badge);
  }

  function initAfterpay() {
    if (!window.location.pathname.includes('/products/')) return;
    renderBadge(getPrice());

    // The theme's product-info.js REPLACES the whole price block on variant change,
    // so anything observing (or listening inside) that subtree dies with it. Watch
    // the stable info container instead, and use the theme's real pub/sub event —
    // 'variant:changed' does not exist in this theme and never fired.
    let pending = null;
    function scheduleRender() {
      clearTimeout(pending);
      pending = setTimeout(function () { renderBadge(getPrice()); }, 60);
    }
    function ownMutation(m) {
      const lists = [m.addedNodes, m.removedNodes];
      for (let l = 0; l < 2; l++) {
        for (let i = 0; i < lists[l].length; i++) {
          if (lists[l][i].id === 'sk-afterpay') return true;
        }
      }
      return false;
    }

    const stableRoot = document.querySelector('.product__info-container') || document.body;
    new MutationObserver(function (muts) {
      for (let i = 0; i < muts.length; i++) {
        if (!ownMutation(muts[i])) { scheduleRender(); return; }
      }
    }).observe(stableRoot, { childList: true, subtree: true, characterData: true });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { scheduleRender(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAfterpay(); });
  } else {
    initAfterpay();
  }
})();
